import { getPath } from '@/router/common'

const baseUrl = {
  title: '理赔管理',
  path: 'ClaimsSettlement'
}

export default [
  {
    path: getPath('ClaimsSettlementAdd', baseUrl),
    name: 'ClaimsSettlementAdd',
    component: () => import(/* webpackChunkName: "ClaimsSettlementAdd" */ '@/views/qualityManage/claimsSettlement/claimsSettlementAdd/index.vue'),
    meta: {
      title: '理赔申请'
    }
  },
  {
    path: getPath('ClaimsSettlementApply', baseUrl),
    name: 'ClaimsSettlementApply',
    component: () => import(/* webpackChunkName: "ClaimsSettlementApply" */ '@/views/qualityManage/claimsSettlement/claimsSettlementApply/index.vue'),
    meta: {
      title: '理赔查询处理'
    }
  },
  {
    path: getPath('TrilateralClaimsSettlementAdd', baseUrl),
    name: 'TrilateralClaimsSettlementAdd',
    component: () => import(/* webpackChunkName: "ClaimsSettlementApply" */ '@/views/qualityManage/claimsSettlement/trilateralClaimsSettlementAdd/index.vue'),
    meta: {
      title: '理赔申请'
    }
  }
]
